module.exports = __webpack_public_path__ + "static/media/15_zenly_0_88.52.30752565.png";